import { useState } from "react";
import type { ReleaseNote } from "../../types/releaseNotes";
import { ReleaseNoteCard } from "./ReleaseNoteCard";

interface ReleaseNotesListProps {
  releaseNotes: ReleaseNote[];
}

export const ReleaseNotesList = ({ releaseNotes }: ReleaseNotesListProps) => {
  const [expanded, setExpanded] = useState<Set<string>>(new Set());

  const toggleExpanded = (id: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);

      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  };

  return (
    <div className="grid gap-3">
      {releaseNotes.map((rn) => (
        <ReleaseNoteCard
          key={rn.documentId}
          releaseNote={rn}
          expanded={expanded.has(rn.documentId)}
          onToggleExpanded={toggleExpanded}
        />
      ))}
    </div>
  );
};
